import React from "react";

const UserContext = React.createContext({ currentUser: {} });

export default UserContext;
